/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import { stackCenterGap } from "../../../../styles/utilStyles";
import { Info, Replay } from "@mui/icons-material";
import { buildDetailedPanelStyles } from "../../styles";
import { permissionListIncludes } from "../../../../utils/helperFunctions";

const StepBox = ({ step, id, showRetryDialog, retryPermissionList }) => {
  return (
    <Box sx={buildDetailedPanelStyles.stepMainBox}>
      <Typography
        variant="h5"
        sx={buildDetailedPanelStyles.stepName(step?.status)}
      >
        {step?.stepName}
      </Typography>

      {step?.status === "FAILED" ? (
        <Tooltip title={<Typography variant="body2">{step?.error}</Typography>}>
          <Info sx={buildDetailedPanelStyles.stepErrorIcon} flex="1" />
        </Tooltip>
      ) : (
        <></>
      )}
      <Box sx={stackCenterGap} />
      {permissionListIncludes(retryPermissionList, id) ? (
        <IconButton
          sx={buildDetailedPanelStyles.retryIcon}
          flex="1"
          onClick={() => {
            showRetryDialog(
              `Retry workflow from step ${step?.stepName} onwards`,
              { stepName: step?.stepName },
              id
            );
          }}
        >
          <Replay />
        </IconButton>
      ) : (
        <></>
      )}
    </Box>
  );
};

export default StepBox;
